// extracted by mini-css-extract-plugin
export default {"heading":"_6q1P2ipvsFYa9gMljwlcC","actionList":"fBqNDGmae5Gwa8ZdGhE-g","actionItem":"_3uqlTkJCUnvTV8l1p7_417"};